import { render } from "./houseCustomerService.vue?vue&type=template&id=870f79f6&scoped=true"
import script from "./houseCustomerService.vue?vue&type=script&lang=js"
export * from "./houseCustomerService.vue?vue&type=script&lang=js"

import "./houseCustomerService.vue?vue&type=style&index=0&id=870f79f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-870f79f6"]])

export default __exports__